import React, { createContext, useState } from "react";
import AppRouter from "./Router";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { DictionaryProvider } from "./contexts/dictionary";
import { DeviceProvider } from "./contexts/DeviceContext";
import { LoaderProvider } from "./contexts/LoaderContext";
import { ContactProvider } from "./contexts/ContactContext";
import { PopupProvider } from "./contexts/PopupContext";
import { MantineProvider } from '@mantine/core';
import WhatsAppButton from "./components/buttons/Whatsapp";
import { MetaProvider } from "./contexts/HelmetContext";
import { VendorProvider } from "./contexts/VendorContext";


export const Appcontext = createContext({
  isAuth: "user",
  setIsAuth: (auth: string) => { }
});

const App = () => {
  const [isAuth, setIsAuth] = useState("user");
  return (

    <>
      <div id="recaptcha-container" style={{ minHeight: "1px" }} />
      <Appcontext.Provider value={{ isAuth, setIsAuth }}>
        <LoaderProvider>
        <MetaProvider>
        




          <DeviceProvider>
            <PopupProvider>
              <VendorProvider>
              <ContactProvider>
                <DictionaryProvider>
                  <MantineProvider>
                     <WhatsAppButton phoneNumber="972507278533" message="שלום, אני מעוניין בפרטים נוספים" />
                    <AppRouter />
                  </MantineProvider>
                </DictionaryProvider>
              </ContactProvider>
              </VendorProvider>
            </PopupProvider>
          </DeviceProvider>
        </MetaProvider>

        </LoaderProvider>
      </Appcontext.Provider>
    </>


  );
};

export default App;
